import actions from 'redux/actions'
import { constants, snowplow } from 'common/helpers'

import messages from './messages'

import generateButton from '../generateButton/generateButton'


export default generateButton({
  displayName: 'AddToCartButton',
  action: actions.models.cart.addItem,
  defaultTitle: messages.defaultTitle,
  withLoading: true,
  onClick: (props) => {
    const {
      product: { id, name, price, category, upchargePrice },
      snowplowMetadata: { placement, sectionTab },
    } = props

    let realUpchargePrice = (String(upchargePrice).match(/\d+(?:\.\d+)?/) || [])[0]
    if (realUpchargePrice) {
      realUpchargePrice = parseFloat(realUpchargePrice)
      realUpchargePrice = realUpchargePrice / 100
    }

    snowplow.track(constants.snowplowEvents.addToCart, {
      productId: id,
      productName: name,
      productPrice: price,
      productCategory: category,
      upchargePrice: realUpchargePrice ? realUpchargePrice : null,
      sectionTab,
      placement,
    }, false)
  },
})
